export default __webpack_public_path__ + "static/media/19_photo.6ecea1cf.jpeg";